import { render } from "./TitleScreen.vue?vue&type=template&id=09478ae1&scoped=true"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import "./TitleScreen.vue?vue&type=style&index=0&id=09478ae1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09478ae1"]])

export default __exports__